import React, { Component } from "react";
import "./Main.css";
import DynamicGrid from "./DynamicGrid";
import { Redirect } from "react-router-dom";

export class OutstandingInvoicesDashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Records: [],
		};
		this.getData();
	}
	async getData() {
		const data = await fetch("Dashboard/GetOutstandingInvoices", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
		});
		var res = await data.json();
		this.setState({ Records: res });
	}
	navClientBuilding(item) {
		this.setState({ ClientPortalRoute: "/clientportal/" + item.buildings_id });
	}

	componentDidUpdate(prevProps) {}

	render() {
		const Settings = {
			ShowDateFilter: false,
			SortColumn: "building_name",
			Condensed: true,
			ShowBuildingsFilter: true,
		};

		const config = [
			{
				header: "Building Name",
				columnName: "building_name",
				visible: true,
				typeCode: "LINK",
				OnClick: (row) => {
					this.navClientBuilding(row);
				},
			},
			{ header: "Outstanding Balance", columnName: "amount", visible: true, typeCode: "$" },
		];
		return (
			<div className="col-md-6 col-12" style={{ backgroundColor: "#ebebeb", padding: "4px", flex: 1, display: "flex", flexDirection: "column", maxHeight: "100%", float: "left" }}>
				<DynamicGrid Title={"Outstanding Balances"} Configuration={config} DataSet={this.state.Records} Settings={Settings} />
				{this.state.ClientPortalRoute && <Redirect to={this.state.ClientPortalRoute}></Redirect>}
			</div>
		);
	}
}
